import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">ZAKIR BIN ALAM ZIAN</span> from
            <span className="purple"> Comilla,Bangladesh.</span>
            <br />I am a junior web-devloper ( Responsible for assisting with the creation of websites and updating existing web applications using scripting languages ).
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Indoor & Outdoor Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
            "Never Stop Learning."{" "}
          </p>
          <footer className="blockquote-footer">Zian</footer>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
